import { StyleSheet } from 'react-native';
import cStyles from '@dkrm/general-libs/theme/styles';
import colors from '@dkrm/ui-kit-basic/colors';
export const C_BLACK_PURE_30 = 'rgba(0,0,0,.3)';
export const C_BLACK_PURE_60 = 'rgba(0,0,0,.6)';
export default StyleSheet.create({
  viewerContainer: {
    ...cStyles.height100,
    ...cStyles.width100,
    ...cStyles.bgb,
    ...cStyles.man
  },
  modal: {
    margin: 0
  },
  closeButtonContainer: {
    ...cStyles.abs,
    ...cStyles.paxxl,
    top: 0,
    left: 0,
    zIndex: 1
  },
  arrowContainer: {
    ...cStyles.flexMiddle,
    ...cStyles.brn,
    ...cStyles.bgw,
    height: 80,
    width: 40,
    opacity: 0.75
  },
  leftArrowContainer: {
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6
  },
  rightArrowContainer: {
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6
  },
  footerContainer: {
    ...cStyles.width100
  },
  footer: {
    ...cStyles.phxxl,
    marginBottom: 80,
    zIndex: 1
  },
  footerIndicator: {
    ...cStyles.pvs,
    ...cStyles.phm,
    ...cStyles.mbl,
    ...cStyles.brs,
    backgroundColor: colors.C_WHITE_100,
    alignSelf: 'flex-start'
  },
  gradientTop: {
    ...cStyles.width100,
    ...cStyles.abs,
    height: 80,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1
  },
  gradientBottom: {
    ...cStyles.width100,
    ...cStyles.abs,
    height: 160,
    bottom: 0
  }
});